export type BaselineStatus={
  sourceId:string;repository:string;repositoryId:string;defaultRef:string;expectedSha:string|null;headVerifiedAt:string|null;
  state:'enabled'|'paused'|'revoked';epoch:number;latestAttempt:Record<string,unknown>|null;lastComplete:Record<string,unknown>|null;
  setup?:{workflowState:'unknown'|'missing'|'enabled'|'disabled';checkedAt:string|null};
  usage:{bytes:number;rows:number;maxBytes:number;maxRows:number};
};
export function baselineSummary(status:BaselineStatus|null) {
  if(!status)return 'GitHub baseline is not connected.';
  if(status.state!=='enabled')return `GitHub baseline ${status.state}. Saved measurements remain available.`;
  const latest=status.latestAttempt;
  if(!status.expectedSha)return 'Connected; the current default-branch revision has not been verified.';
  if(!latest&&status.setup?.workflowState==='missing')return 'GitHub connected. The main-branch workflow still needs installation.';
  if(!latest&&status.setup?.workflowState==='disabled')return 'The PhaseDrift baseline workflow is disabled in GitHub.';
  if(latest?.reason==='github_run_queued'&&latest.commit_sha===status.expectedSha)return 'The main-branch scan is queued, waiting for an available PhaseDrift runner.';
  if(!latest||latest.commit_sha!==status.expectedSha)return `Waiting for a baseline of ${status.defaultRef} ${status.expectedSha.slice(0,8)}.`;
  return `${status.defaultRef} ${status.expectedSha.slice(0,8)} · ${String(latest.state)} baseline`;
}

export function baselineStage(status:BaselineStatus) {
  if(status.state!=='enabled')return status.state;
  if(status.latestAttempt&&status.latestAttempt.commit_sha!==status.expectedSha)return status.setup?.workflowState==='disabled'?'Workflow disabled':status.setup?.workflowState==='missing'?'Workflow needed':'Awaiting current scan';
  if(status.latestAttempt?.reason==='github_run_queued')return 'Waiting for runner';
  if(status.latestAttempt)return status.latestAttempt.state==='complete'?'Current':status.latestAttempt.state==='running'?'Measuring':String(status.latestAttempt.state);
  if(status.setup?.workflowState==='missing')return 'Workflow needed';
  if(status.setup?.workflowState==='disabled')return 'Workflow disabled';
  return 'Awaiting first scan';
}
